export const version = '10.1.0'
// Note: This file is automatically generated when building math.js.
// Changes made in this file will be overwritten.
